module.exports = __webpack_public_path__ + "img/GP.bd1434ad.png";